<template>
    <div class="custom-index">
        <div class="heard">
            <div class="title-img"><img :src="titleUrl" alt="" /></div>
            <div class="title">{{ infoName }}</div>
            <div class="title-time">
                <el-radio-group v-model="tabPosition">
                    <el-radio-button label="month">月</el-radio-button>
                    <el-radio-button label="season">季</el-radio-button>
                    <el-radio-button label="year">年</el-radio-button>
                </el-radio-group>
                <div class="time-ll">
                    {{ newTime.getHours() < 10 ? '0' + newTime.getHours() : newTime.getHours() }}:{{ newTime.getMinutes() < 10 ? '0' + newTime.getMinutes() : newTime.getMinutes() }}:{{ newTime.getSeconds() < 10 ? '0' + newTime.getSeconds() : newTime.getSeconds() }}
                </div>
                <div class="time-li">
                    <div style="text-align: right;">
                        <span v-if="newTime.getDay() === 0">星期日</span>
                        <span v-else-if="newTime.getDay() === 1">星期一</span>
                        <span v-else-if="newTime.getDay() === 2">星期二</span>
                        <span v-else-if="newTime.getDay() === 3">星期三</span>
                        <span v-else-if="newTime.getDay() === 4">星期四</span>
                        <span v-else-if="newTime.getDay() === 5">星期五</span>
                        <span v-else-if="newTime.getDay() === 6">星期六</span>
                    </div>
                    <div style="margin-top: 5px;">
                        {{newTime.getFullYear()}}-{{newTime.getMonth() + 1}}-{{ newTime.getDate() < 10 ? '0' + newTime.getDate() : newTime.getDate() }}
                    </div>
                </div>
            </div>
        </div>

        <div class="content">
            <div class="content-div content-left" style="padding-left: 5px;">
                <div class="content-ul changeClolr">
                    <div class="right-li-top"></div>
                    <div class="right-li-bottom"></div>
                    <div class="right-li-content">
                        <div class="center-title changeClolr">运行信息</div>
                        <div
                            style="width: 100%;height: calc(100% - 45px);display: flex;justify-content: space-between;">
                            <div class="runTime">
                                <div class="numberli">{{ parseInt((funNum % 100000)/10000) }}</div>
                                <div class="numberli">{{ parseInt((funNum % 10000)/1000) }}</div>
                                <div class="numberli">{{ parseInt((funNum % 1000)/100) }}</div>
                                <div class="numberli">{{ parseInt((funNum % 100)/10) }}</div>
                                <div class="numberli">{{ parseInt(funNum % 10) }}</div>
                            </div>
                            <div class="runTime">
                                <div class="numberli" v-if="mileage > 99999">{{ parseInt((mileage % 1000000)/100000) }}</div>
                                <div class="numberli">{{ parseInt((mileage % 100000)/10000) }}</div>
                                <div class="numberli">{{ parseInt((mileage % 10000)/1000) }}</div>
                                <div class="numberli">{{ parseInt((mileage % 1000)/100) }}</div>
                                <div class="numberli">{{ parseInt((mileage % 100)/10) }}</div>
                                <div class="numberli">{{ parseInt(mileage % 10) }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="right-li-time">运行时长（天）</div>
                    <div class="right-li-mileage">运行里程（KM）</div>
                </div>
                <div class="content-ul changeClolr">
                    <div class="right-li-top"></div>
                    <div class="right-li-bottom"></div>
                    <div class="right-li-content">
                        <div class="left-title changeClolr">
                            <div>预计提高工作效率</div>
                            <div>预计节约成本</div>
                        </div>
                        <div style="position: absolute;top: 60px;left: 0;width: 100%;">
                            <div
                                style="position: absolute;left: 0;width: 50%;text-align: center;color: white;font-size: 16px;font-weight: 600;">
                                对比人工预计增加 &nbsp; <span
                                    style="font-size: 24px;color: rgb(0,172,254);font-weight: 700;">{{ Math.round(working/8) }}</span>
                                &nbsp; 天工作时长</div>
                            <div
                                style="position: absolute;right: 0;width: 50%;text-align: center;color: white;font-size: 16px;font-weight: 600;">
                                对比人工预计节省 &nbsp; <span
                                    style="font-size: 24px;color: rgb(0,172,254);font-weight: 700;">{{ (workingCost/10000).toFixed(1) }}</span>
                                &nbsp; 万</div>
                        </div>
                        <div
                            style="width: 100%;height: calc(100% - 55px);display: flex;justify-content: space-between;margin-top: 10px;">
                            <div style="width: 47%;height: 100%;display: flex;justify-content: space-between;margin: 0 1.5%;"
                                id="echar3-1">
                            </div>
                            <div style="width: 47%;height: 100%;margin: 0 1.5%;" id="echar3-2"></div>
                        </div>
                    </div>
                </div>
                <div class="content-ul changeClolr">
                    <div class="right-li-top"></div>
                    <div class="right-li-bottom"></div>
                    <div class="right-li-content">
                        <div class="left-title changeClolr">
                            <div>机器人值班统计</div>
                            <div>机器人运行里程统计</div>
                        </div>
                        <div
                            style="width: 100%;height: calc(100% - 45px);display: flex;justify-content: space-between;">
                            <div style="width: 50%;height: 100%;display: flex;justify-content: space-between;"
                                id="echar5-1">
                            </div>
                            <div style="width: 50%;height: 100%;" id="echar5-2"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="content-div content-right" style="padding-right: 5px;">
                <div class="content-ul changeClolr">
                    <div class="right-li-top"></div>
                    <div class="right-li-bottom"></div>
                    <div class="right-li-content">
                        <div class="left-title changeClolr">
                            <div>机器人运行场景统计</div>
                            <div>机器人巡检次数统计</div>
                        </div>
                        <div
                            style="width: 100%;height: calc(100% - 45px);display: flex;justify-content: space-between;">
                            <div style="width: 50%;height: 100%;display: flex;justify-content: space-between;"
                                id="echar2-1">
                            </div>
                            <div style="width: 50%;height: 100%;" id="echar2-2"></div>
                        </div>
                    </div>
                </div>
                <div class="content-ul changeClolr">
                    <div class="right-li-top"></div>
                    <div class="right-li-bottom"></div>
                    <div class="right-li-content">
                        <div class="left-title changeClolr">
                            <div>地图与机器人数据统计</div>
                            <div>地图事件数据统计</div>
                        </div>
                        <div
                            style="width: 100%;height: calc(100% - 45px);display: flex;justify-content: space-between;">
                            <div style="width: 50%;height: 100%;display: flex;justify-content: flex-start;">
                                <div style="width: 50%;height: 100%;" id="echar4-1"></div>
                                <div
                                    style="width: 49%;height: 100%;display: flex;flex-direction: column;align-items: flex-end;overflow-y: auto;">
                                    <div class="echar6li" v-if="mapText.list.length > 0">地图上共有机器人
                                        <span>{{ mapText.num }}</span> 台
                                    </div>
                                    <div class="echar6li" v-for="(obj, index) in mapText.list" :key="index+10">
                                        {{ obj.name }} <span>{{ obj.num }}</span> 台
                                    </div>
                                </div>
                            </div>
                            <div style="width: 50%;height: 100%;" id="echar4-2"></div>
                        </div>
                    </div>
                </div>
                <div class="content-ul changeClolr">
                    <div class="right-li-top"></div>
                    <div class="right-li-bottom"></div>
                    <div class="right-li-content">
                        <div class="left-title changeClolr">
                            <div>事件数据统计</div>
                            <div>各类事件完成率统计</div>
                        </div>
                        <div
                            style="width: 100%;height: calc(100% - 45px);display: flex;justify-content: space-between;">
                            <div style="width: 50%;height: 100%;display: flex;justify-content: flex-start;">
                                <div style="width: 50%;height: 100%;" id="echar6-1"></div>
                                <div
                                    style="width: 49%;height: 100%;display: flex;flex-direction: column;align-items: flex-end;overflow-y: auto;">
                                    <div class="echar6li" v-for="(obj, index) in eventTextList" :key="index+10">
                                        {{ obj.name }} <span>{{ obj.number }}</span> {{ obj.type }}
                                    </div>
                                </div>
                            </div>
                            <div style="width: 50%;height: 100%;" id="echar6-2"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<style scoped lang="less">
    .heard /deep/ .el-radio-button__inner {
        background-color: rgb(27, 31, 61);
        padding: 10px 16px;
        border: none;
        color: white;
    }

    .heard /deep/ .el-radio-button__orig-radio:checked+.el-radio-button__inner {
        color: #FFF;
        background-color: #409EFF;
        border-color: #409EFF;
    }
</style>

<script>
    import {
        getItem
    } from '@/utils/auth'
    import {
        rIndex
    } from '@/api/index'
    import {
        intervalRunTime,
        eventChart,
        mapEventChart,
        runMileage,
        robotStatisticsNum,
        robotSiteNum,
        routeRobotNum,
        eventFinish,
        robotWorkingHours,
        robotWorkingCost,
        robotRunMileageStatistics,
        robotDutyStatistics,
        tenantInfoName
    } from '@/api/customIndex'
    import '@/page/customIndex/statistics/index.less'

    export default {
        name: 'customindex',
        data() {
            return {
                newTime: new Date(),
                nowTime: new Date().getTime(),
                titleUrl: require('../../../../static/img/title.png'),
                tabPosition: 'month',
                eventTextList: [],
                mapText: {
                    num: 0,
                    list: []
                },
                funNum: 0,
                mileage: 0,
                working: 0,
                workingCost: 0,
                infoName: ''
            }
        },
        mounted() {
          let that = this
          // 定时执行保持token有效
          setInterval(() => {
              that.newTime = new Date()
          }, 1000)
          setInterval(() => {
              rIndex()
          }, 1000 * 60 * 60 * 5)
          that.tenantInfoName(getItem('tenantInfoId'))
        },
        methods: {
            tenantInfoName(id) {
                let that = this
                tenantInfoName(id).then(res => {
                    that.infoName = res.data.tenantInfoName
                })
            },
            mapEventChart(id, type) {
                let that = this
                mapEventChart(id, type).then(res => {
                    that.Echarts42(res.data)
                })
            },
            routeRobotNum(id, type) {
                let that = this
                routeRobotNum(id, type).then(res => {
                    if (res.data) {
                        that.Echarts41(res.data)
                        that.mapText.list = res.data
                        that.mapText.num = 0
                        res.data.forEach(v => {
                            that.mapText.num += Number(v.num)
                        })
                    }
                })
            },
            eventFinish(id, type) {
                let that = this
                eventFinish(id, type).then(res => {
                    that.Echarts62(res.data)
                })
            },
            robotSiteNum(id, type) {
                let that = this
                robotSiteNum(id, type).then(res => {
                    that.Echarts22(res.data)
                })
            },
            robotStatisticsNum(id, type) {
                let that = this
                robotStatisticsNum(id, type).then(res => {
                    that.Echarts21(res.data)
                })
            },
            runMileage(id, type) {
                let that = this
                runMileage(id, type).then(res => {
                    that.mileage = Number(res.data.mileage)
                })
            },
            intervalRunTime(id, type) {
                let that = this
                intervalRunTime(id, type).then(res => {
                    that.funNum = Number(res.data.days)
                })
            },
            robotWorkingHours(id, type) {
                let that = this
                robotWorkingHours(id, type).then(res => {
                    that.Echarts31(res.data)
                    that.working = Number(res.data[0].num) - Number(res.data[1].num) > 0 ? Number(res.data[0]
                        .num) - Number(res.data[1].num) : Number(res.data[1].num) - Number(res.data[0].num)
                })
            },
            robotWorkingCost(id, type) {
                let that = this
                robotWorkingCost(id, type).then(res => {
                    that.Echarts32(res.data)
                    that.workingCost = Number(res.data[1].num) - Number(res.data[0].num) > 0 ? Number(res.data[
                        1].num) - Number(res.data[0].num) : Number(res.data[0].num) - Number(res.data[1]
                        .num)
                })
            },
            eventChart(id, type) {
                let that = this
                eventChart(id, type).then(res => {
                    if (res.data) {
                        that.Echarts61(res.data)
                        that.eventTextList = []
                        that.eventTextList.push({
                            name: '事件类型汇总',
                            number: res.data.length,
                            type: '类'
                        })
                        res.data.forEach(v => {
                            that.eventTextList.push({
                                name: v.name,
                                number: v.number,
                                type: '条'
                            })
                        })
                    }
                })
            },
            robotRunMileageStatistics(id, type) {
                let that = this
                robotRunMileageStatistics(id, type).then(res => {
                    that.Echarts52(res.data)
                })
            },
            robotDutyStatistics(id, type) {
                let that = this
                robotDutyStatistics(id, type).then(res => {
                    that.Echarts51(res.data)
                })
            },
            // 值班统计
            Echarts51(echarArray) {
                var myChart = this.$echarts.init(document.getElementById('echar5-1'))
                myChart.clear();
                let newLineData = []
                if (echarArray.mapList.length === 0) {
                    let aaalist = []
                    echarArray.dateList.forEach(rv => {
                        aaalist.push(0)
                    })
                    newLineData.push({
                        name: '',
                        data: aaalist,
                        type: "line",
                        label: {
                            show: true,
                            position: 'top'
                        }
                    })
                } else {
                    echarArray.mapList.forEach(v => {
                        newLineData.push({
                            name: v.name,
                            data: v.valueList,
                            type: "line",
                            // stack: "Total",
                            // emphasis: {
                            //     focus: "series"
                            // },
                            // areaStyle: {},
                            label: {
                                show: true,
                                position: 'top'
                            }
                        })
                    })
                }

                var option = {
                    tooltip: {
                        trigger: 'axis'
                    },
                    grid: {
                        top: '10%',
                        left: '5%',
                        right: '4%',
                        bottom: '2%',
                        containLabel: true
                    },
                    xAxis: {
                        type: 'category',
                        boundaryGap: false,
                        axisLabel: {
                            rotate: 40
                        },
                        data: echarArray.dateList
                    },
                    yAxis: {
                        type: 'value',
                        axisLabel: {
                            formatter: '{value} h'
                        },
                        data: [1,2,3,4,5]
                    },
                    series: newLineData
                };
                myChart.setOption(option)
            },
            // 里程统计
            Echarts52(echarArray) {
                var myChart = this.$echarts.init(document.getElementById('echar5-2'))
                myChart.clear();

                let newLineData = []
                if (echarArray.mapList.length === 0) {
                    let aaalist = []
                    echarArray.dateList.forEach(rv => {
                        aaalist.push(0)
                    })
                    newLineData.push({
                        name: '',
                        data: aaalist,
                        type: "line",
                        label: {
                            show: true,
                            position: 'top'
                        }
                    })
                } else {
                    echarArray.mapList.forEach(v => {
                        newLineData.push({
                            name: v.name,
                            data: v.valueList,
                            type: "line",
                            label: {
                                show: true,
                                position: 'top'
                            }
                        })
                    })
                }

                var option = {
                    tooltip: {
                        trigger: 'axis'
                    },
                    grid: {
                        top: '10%',
                        left: '5%',
                        right: '4%',
                        bottom: '2%',
                        containLabel: true
                    },
                    xAxis: {
                        type: 'category',
                        boundaryGap: false,
                        axisLabel: {
                            rotate: 40
                        },
                        data: echarArray.dateList
                    },
                    yAxis: {
                        type: 'value',
                        axisLabel: {
                            formatter: '{value} km'
                        }
                    },
                    series: newLineData
                };
                myChart.setOption(option)
            },
            // 节省成本
            Echarts32(echarArray) {
                var myChart = this.$echarts.init(document.getElementById('echar3-2'))
                myChart.clear();
                echarArray.forEach((res, index) => {
                    res.value = Number(res.num)
                })
                let datas = [echarArray]
                var option = {
                    grid: {
                        left: '7%',
                        right: '7%',
                        bottom: '0%',
                        top: '50%'
                    },
                    tooltip: {
                        trigger: 'item',
                        formatter: '{b}: {c}/元 ({d}%)'
                    },
                    series: datas.map(function(data, idx) {
                        return {
                            type: 'pie',
                            radius: [30, '70%'],
                            center: ["50%", "55%"],
                            label: {
                                alignTo: 'edge',
                                formatter: '{time|{c}} / 元\n{name|{b}}',
                                edgeDistance: 5,
                                lineHeight: 20,
                                rich: {
                                    time: {
                                        fontSize: 15,
                                    },
                                    textStyle: {
                                        color: 'black'
                                    }
                                }
                            },
                            labelLine: {
                                length: 5,
                                length2: 0,
                                maxSurfaceAngle: 80
                            },
                            labelLayout(params) {
                                var isLeft = params.labelRect.x < myChart.getWidth() / 2
                                var points = params.labelLinePoints
                                points[2][0] = isLeft ? params.labelRect.x : params.labelRect.x + params
                                    .labelRect.width
                                return {
                                    labelLinePoints: points
                                }
                            },
                            data: data
                        }
                    })
                }
                myChart.setOption(option)
            },
            // 提高工作效率
            Echarts31(echarArray) {
                var myChart = this.$echarts.init(document.getElementById('echar3-1'))
                myChart.clear();
                echarArray.forEach((res, index) => {
                    res.value = Number(res.num)
                })
                let datas = [echarArray]
                var option = {
                    grid: {
                        left: '7%',
                        right: '7%',
                        bottom: '0%',
                        top: '50%'
                    },
                    tooltip: {
                        trigger: 'item',
                        formatter: '{b}: {c}/时 ({d}%)'
                    },
                    series: datas.map(function(data, idx) {
                        return {
                            type: 'pie',
                            radius: [30, '70%'],
                            center: ["50%", "55%"],
                            label: {
                                alignTo: 'edge',
                                formatter: '{time|{c}} / 时\n{name|{b}}',
                                edgeDistance: 5,
                                lineHeight: 20,
                                rich: {
                                    time: {
                                        fontSize: 15,
                                    },
                                    textStyle: {
                                        color: 'black'
                                    }
                                }
                            },
                            labelLine: {
                                length: 5,
                                length2: 0,
                                maxSurfaceAngle: 80
                            },
                            labelLayout(params) {
                                var isLeft = params.labelRect.x < myChart.getWidth() / 2
                                var points = params.labelLinePoints
                                points[2][0] = isLeft ? params.labelRect.x : params.labelRect.x + params
                                    .labelRect.width
                                return {
                                    labelLinePoints: points
                                }
                            },
                            data: data
                        }
                    })
                }
                myChart.setOption(option)
            },
            // 地图与机器人数据统计
            Echarts41(echarArray) {
                var myChart = this.$echarts.init(document.getElementById('echar4-1'))
                myChart.clear();
                echarArray.forEach(res => {
                    res.value = Number(res.num)
                })
                let datas = [echarArray]
                var option = {
                    grid: {
                        left: '5%',
                        right: '4%',
                        bottom: '0%',
                        top: '50%'
                    },
                    tooltip: {
                        trigger: 'item',
                        formatter: '{b}: {c} ({d}%)'
                    },
                    series: datas.map(function(data, idx) {
                        return {
                            type: 'pie',
                            radius: [30, '60%'],
                            center: ["50%", "50%"],
                            label: {
                                alignTo: 'edge',
                                formatter: '{time|{c}}\n{name|{b}}',
                                edgeDistance: 5,
                                lineHeight: 20,
                                rich: {
                                    time: {
                                        fontSize: 15,
                                    },
                                    textStyle: {
                                        color: 'black'
                                    }
                                }
                            },
                            labelLine: {
                                length: 5,
                                length2: 0,
                                maxSurfaceAngle: 80
                            },
                            labelLayout(params) {
                                var isLeft = params.labelRect.x < myChart.getWidth() / 2
                                var points = params.labelLinePoints
                                points[2][0] = isLeft ? params.labelRect.x : params.labelRect.x + params
                                    .labelRect.width
                                return {
                                    labelLinePoints: points
                                }
                            },
                            data: data
                        }
                    })
                }
                myChart.setOption(option)
            },
            // 地图事件数据统计
            Echarts42(echarArray) {
                var myChart = this.$echarts.init(document.getElementById('echar4-2'))
                myChart.clear();
                let xData = []
                let yData = []
                echarArray.forEach(res => {
                    xData.push(res.name)
                    yData.push(Number(res.number))
                })
                let option = {
                    xAxis: {
                        type: 'category',
                        data: xData,
                        axisLabel: {
                            rotate: 30,
                            show: true,
                            textStyle: {
                                color: 'rgb(110,112,121)'
                            },
                            fontSize: 14
                        }
                    },
                    yAxis: {
                        type: 'value',
                        axisLabel: {
                            show: true,
                            textStyle: {
                                color: 'rgb(110,112,121)'
                            },
                            fontSize: 14
                        },
                        minInterval: 1
                    },
                    grid: {
                        top: '10%',
                        left: '2%',
                        bottom: '2%',
                        right: '1%',
                        containLabel: true,
                    },
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'cross'
                        }
                    },
                    series: [{
                        name: '事件数',
                        data: yData,
                        type: 'bar',
                        backgroundStyle: {
                            color: 'rgba(180, 180, 180, 0.2)'
                        },
                        itemStyle: {
                            normal: {
                                color: function(params) {
                                    var colorList = ['rgb(145,204,117)', 'rgb(84,112,198)', '#336699',
                                        '#CC6699',
                                        '#FFFFCC', '#009966', '#663300'
                                    ]
                                    return colorList[params.dataIndex]
                                },
                                label: {
                                    show: true,
                                    formatter: '{c}',
                                    position: 'top',
                                    fontWeight: 600,
                                    fontSize: 15
                                }
                            }
                        }
                    }]
                };
                myChart.setOption(option)
            },
            // 机器人运行场景统计
            Echarts21(echarArray) {
                var myChart = this.$echarts.init(document.getElementById('echar2-1'))
                myChart.clear();
                let ename = []
                let ednum = []

                echarArray.forEach(res => {
                    ename.push(res.name)
                    ednum.push(res.num)
                })

                let option = {
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'shadow'
                        }
                    },
                    grid: {
                        left: '3%',
                        right: '5%',
                        bottom: '2%',
                        top: '2%',
                        containLabel: true
                    },
                    xAxis: {
                        type: 'value',
                        axisLabel: {
                            show: true,
                            textStyle: {
                                color: 'rgb(110,112,121)'
                            },
                            fontSize: 14
                        },
                        minInterval: 1
                    },
                    yAxis: {
                        type: 'category',
                        data: ename.reverse(),
                        axisLabel: {
                            show: true,
                            textStyle: {
                                color: 'rgb(110,112,121)'
                            },
                            fontSize: 14
                        }
                    },
                    series: [{
                        name: '机器人数量',
                        type: 'bar',
                        itemStyle: {
                            normal: {
                                // 定制显示（按顺序）
                                color: function(params) {
                                    var colorList = ['rgb(84,112,198)', 'rgb(145,204,117)', '#336699',
                                        '#CC6699',
                                        '#FFFFCC', '#009966', '#663300'
                                    ]
                                    return colorList[params.dataIndex]
                                },
                                label: {
                                    show: true,
                                    formatter: '{c}',
                                    position: 'right',
                                    fontWeight: 600,
                                    fontSize: 15
                                }
                            }
                        },
                        data: ednum.reverse()
                    }]
                };
                myChart.setOption(option)
            },
            // 机器人巡检次数统计
            Echarts22(echarArray) {
                var myChart = this.$echarts.init(document.getElementById('echar2-2'))
                myChart.clear();
                let xData = []
                let yData = []
                echarArray.forEach(res => {
                    xData.push(res.name)
                    yData.push(res.num)
                })

                let option = {
                    xAxis: {
                        type: 'category',
                        data: xData,
                        axisLabel: {
                            rotate: 30,
                            show: true,
                            textStyle: {
                                color: 'rgb(110,112,121)'
                            },
                            fontSize: 14
                        }
                    },
                    yAxis: {
                        type: 'value',
                        axisLabel: {
                            show: true,
                            textStyle: {
                                color: 'rgb(110,112,121)'
                            },
                            fontSize: 14
                        },
                        minInterval: 1
                    },
                    grid: {
                        top: '10%',
                        left: '2%',
                        bottom: '2%',
                        right: '1%',
                        containLabel: true,
                    },
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'cross'
                        }
                    },
                    series: [{
                        name: '巡检次数',
                        data: yData,
                        type: 'bar',
                        backgroundStyle: {
                            color: 'rgba(180, 180, 180, 0.2)'
                        },
                        itemStyle: {
                            normal: {
                                color: function(params) {
                                    var colorList = ['rgb(84,112,198)', 'rgb(145,204,117)', '#336699',
                                        '#CC6699',
                                        '#FFFFCC', '#009966', '#663300'
                                    ]
                                    return colorList[params.dataIndex]
                                },
                                label: {
                                    show: true,
                                    formatter: '{c}',
                                    position: 'top',
                                    fontWeight: 600,
                                    fontSize: 15
                                }
                            }
                        }
                    }]
                };
                myChart.setOption(option)
            },
            // 地图与机器人数据统计
            Echarts61(echarArray) {
                var myChart = this.$echarts.init(document.getElementById('echar6-1'))
                myChart.clear();
                echarArray.map(v => {
                    v.value = Number(v.number)
                })
                var datas = [echarArray]
                var option = {
                    grid: {
                        left: '5%',
                        right: '4%',
                        bottom: '0%',
                        top: '50%'
                    },
                    tooltip: {
                        trigger: 'item',
                        formatter: '{b}: {c} ({d}%)'
                    },
                    series: datas.map(function(data, idx) {
                        return {
                            type: 'pie',
                            radius: [30, '60%'],
                            center: ["50%", "50%"],
                            label: {
                                alignTo: 'edge',
                                formatter: '{time|{c}}\n{name|{b}}',
                                edgeDistance: 5,
                                lineHeight: 20,
                                rich: {
                                    time: {
                                        fontSize: 15,
                                    },
                                    textStyle: {
                                        color: 'black'
                                    }
                                }
                            },
                            labelLine: {
                                length: 5,
                                length2: 0,
                                maxSurfaceAngle: 80
                            },
                            labelLayout(params) {
                                var isLeft = params.labelRect.x < myChart.getWidth() / 2
                                var points = params.labelLinePoints
                                points[2][0] = isLeft ? params.labelRect.x : params.labelRect.x + params
                                    .labelRect.width
                                return {
                                    labelLinePoints: points
                                }
                            },
                            data: data
                        }
                    })
                }
                myChart.setOption(option)
            },
            // 各类事件完成率统计
            Echarts62(echarArray) {
                var myChart = this.$echarts.init(document.getElementById('echar6-2'))
                myChart.clear();
                let xData = []
                let yData = []
                echarArray.forEach(res => {
                    xData.push(res.name)
                    yData.push(res.completionRate)
                })
                let option = {
                    xAxis: {
                        type: 'category',
                        data: xData,
                        axisLabel: {
                            rotate: 30,
                            show: true,
                            textStyle: {
                                color: 'rgb(110,112,121)'
                            },
                            fontSize: 14
                        }
                    },
                    yAxis: {
                        type: 'value',
                        axisLabel: {
                            show: true,
                            textStyle: {
                                color: 'rgb(110,112,121)'
                            },
                            fontSize: 14
                        }
                    },
                    grid: {
                        top: '10%',
                        left: '2%',
                        bottom: '2%',
                        right: '1%',
                        containLabel: true,
                    },
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'cross'
                        },
                        formatter: function(params) {
                            var html = params[0].name + "<br>";
                            for (var i = 0; i < params.length; i++) {
                                html += params[i].marker + '完成率: ' + params[i].value + '%';
                            }
                            return html + "<br>";
                        }
                    },
                    series: [{
                        data: yData,
                        type: 'bar',
                        backgroundStyle: {
                            color: 'rgba(180, 180, 180, 0.2)'
                        },
                        itemStyle: {
                            normal: {
                                color: function(params) {
                                    var colorList = ['rgb(145,204,117)', 'rgb(84,112,198)', '#336699',
                                        '#CC6699',
                                        '#FFFFCC', '#009966', '#663300'
                                    ]
                                    return colorList[params.dataIndex]
                                },
                                label: {
                                    show: true,
                                    formatter: '{c}%',
                                    position: 'top',
                                    fontWeight: 600,
                                    fontSize: 15
                                }
                            }
                        }
                    }]
                };
                myChart.setOption(option, true)
            },
            // 调用数据
            runAjax(tenID, type) {
                let that = this
                that.runMileage(tenID, type)
                that.intervalRunTime(tenID, type)
                setTimeout(function() {
                    that.eventChart(tenID, type)
                    that.robotStatisticsNum(tenID, type)
                    that.robotSiteNum(tenID, type)
                    that.routeRobotNum(tenID, type)
                    that.eventFinish(tenID, type)
                    that.mapEventChart(tenID, type)
                    that.robotWorkingHours(tenID, type)
                    that.robotWorkingCost(tenID, type)
                    that.robotRunMileageStatistics(tenID, type)
                    that.robotDutyStatistics(tenID, type)
                }, 500)
            }
        },
        watch: {
            tabPosition: {
                deep: true,
                immediate: true,
                handler(val, oldVal) {
                    if (getItem('userInfo').positionType === '1') {
                        let checkType = ''
                        if (val === 'month') {
                            checkType = 1
                        } else if (val === 'season') {
                            checkType = 2
                        } else if (val === 'year') {
                            checkType = 3
                        }
                        this.runAjax(getItem('tenantInfoId'), checkType)
                    }
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/page/customIndex/statistics/index.vue